// extracted by mini-css-extract-plugin
module.exports = {"shimmer":"Shimmer_shimmer__EmpFa","loader":"Shimmer_loader__jjisx"};